module.exports = __webpack_public_path__ + "static/media/radio-unfilled.96b79228.svg";